/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConsumerStatus } from './ConsumerStatus';
import {
    ConsumerStatusFromJSON,
    ConsumerStatusFromJSONTyped,
    ConsumerStatusToJSON,
    ConsumerStatusToJSONTyped,
} from './ConsumerStatus';
import type { ConsumerProjection } from './ConsumerProjection';
import {
    ConsumerProjectionFromJSON,
    ConsumerProjectionFromJSONTyped,
    ConsumerProjectionToJSON,
    ConsumerProjectionToJSONTyped,
} from './ConsumerProjection';
import type { ConsumerBatch } from './ConsumerBatch';
import {
    ConsumerBatchFromJSON,
    ConsumerBatchFromJSONTyped,
    ConsumerBatchToJSON,
    ConsumerBatchToJSONTyped,
} from './ConsumerBatch';
import type { ConsumerWebhook } from './ConsumerWebhook';
import {
    ConsumerWebhookFromJSON,
    ConsumerWebhookFromJSONTyped,
    ConsumerWebhookToJSON,
    ConsumerWebhookToJSONTyped,
} from './ConsumerWebhook';
import type { ConsumerProtocol } from './ConsumerProtocol';
import {
    ConsumerProtocolFromJSON,
    ConsumerProtocolFromJSONTyped,
    ConsumerProtocolToJSON,
    ConsumerProtocolToJSONTyped,
} from './ConsumerProtocol';

/**
 * Consumer model represents a consumer of notifications for a subscription.
 * @export
 * @interface Consumer
 */
export interface Consumer {
    /**
     * Internal unique identifier of the resource, following UUIDv7 format.
     * @type {string}
     * @memberof Consumer
     */
    id: string;
    /**
     * Display name of the consumer.
     * @type {string}
     * @memberof Consumer
     */
    name: string;
    /**
     * 
     * @type {ConsumerProtocol}
     * @memberof Consumer
     */
    protocol: ConsumerProtocol;
    /**
     * 
     * @type {ConsumerStatus}
     * @memberof Consumer
     */
    status: ConsumerStatus;
    /**
     * Timestamp when the consumer was disabled. Null if consumer is active.
     * @type {Date}
     * @memberof Consumer
     */
    disabledAt?: Date;
    /**
     * Whether to include the full Logistics Object body in notifications.
     * 
     * This setting only applies to subscriptions with `notificationType: EVENTS`:
     * - When `true`, the notification includes both the event and the LO body.
     * - When `false` (default), only the event is included.
     * 
     * For `UPDATES` and `ACL` subscriptions, this setting is ignored; the LO is always included.
     * 
     * When enabled, the LO is fetched via the admin API (e.g., `GET /admin/{resource-type}/{id}`).
     * 
     * @type {boolean}
     * @memberof Consumer
     */
    includeLo?: boolean;
    /**
     * 
     * @type {ConsumerProjection}
     * @memberof Consumer
     */
    projection?: ConsumerProjection;
    /**
     * 
     * @type {ConsumerBatch}
     * @memberof Consumer
     */
    batch: ConsumerBatch;
    /**
     * 
     * @type {ConsumerWebhook}
     * @memberof Consumer
     */
    webhook?: ConsumerWebhook;
    /**
     * Creation date of the resource.
     * @type {Date}
     * @memberof Consumer
     */
    createdAt: Date;
    /**
     * Last update date of the resource.
     * @type {Date}
     * @memberof Consumer
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the Consumer interface.
 */
export function instanceOfConsumer(value: object): value is Consumer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('protocol' in value) || value['protocol'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('batch' in value) || value['batch'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ConsumerFromJSON(json: any): Consumer {
    return ConsumerFromJSONTyped(json, false);
}

export function ConsumerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Consumer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'protocol': ConsumerProtocolFromJSON(json['protocol']),
        'status': ConsumerStatusFromJSON(json['status']),
        'disabledAt': json['disabledAt'] == null ? undefined : (new Date(json['disabledAt'])),
        'includeLo': json['includeLo'] == null ? undefined : json['includeLo'],
        'projection': json['projection'] == null ? undefined : ConsumerProjectionFromJSON(json['projection']),
        'batch': ConsumerBatchFromJSON(json['batch']),
        'webhook': json['webhook'] == null ? undefined : ConsumerWebhookFromJSON(json['webhook']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ConsumerToJSON(json: any): Consumer {
    return ConsumerToJSONTyped(json, false);
}

export function ConsumerToJSONTyped(value?: Consumer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'protocol': ConsumerProtocolToJSON(value['protocol']),
        'status': ConsumerStatusToJSON(value['status']),
        'disabledAt': value['disabledAt'] == null ? value['disabledAt'] : value['disabledAt'].toISOString(),
        'includeLo': value['includeLo'],
        'projection': ConsumerProjectionToJSON(value['projection']),
        'batch': ConsumerBatchToJSON(value['batch']),
        'webhook': ConsumerWebhookToJSON(value['webhook']),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

